export default {"src":"/_next/static/media/space.6e00105f.svg","height":710,"width":586,"blurWidth":0,"blurHeight":0};